import { useEffect } from "react";
import { API } from "service/Interceptor";
import { getAccessToken } from "utils/utils";

const PING_MS = 30000;

export async function markPresenceOffline() {
  if (!getAccessToken()) return;
  try {
    await API.post("api/presence/offline", {}, { skipErrorToast: true });
  } catch {
    /* ignore */
  }
}

const usePresenceHeartbeat = () => {
  useEffect(() => {
    let timer;
    const ping = async () => {
      if (!getAccessToken() || document.visibilityState === "hidden") return;
      try {
        await API.post("api/presence/heartbeat", {}, { skipErrorToast: true });
      } catch {
        /* ignore */
      }
    };

    ping();
    timer = window.setInterval(ping, PING_MS);
    const onVis = () => {
      if (document.visibilityState === "visible") ping();
    };
    document.addEventListener("visibilitychange", onVis);

    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, []);
};

export default usePresenceHeartbeat;
